var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1454BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48260662,
    stopColor: "#2517A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5711B6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-arrow-angle-in-circular-button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 26.1295L7.6177 14.5347L18.0676 3.88688L14.2494 0L0 14.5154L15.2005 30L19 26.1295Z",
    transform: "translate(18 16)",
    id: "Path",
    fill: "url(#gradient_1)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0C46.5681 0 60 13.4318 60 30C60 46.5681 46.5681 60 30 60C13.4318 60 0 46.5681 0 30C0 13.4318 13.4318 0 30 0ZM29.9998 2.72726C14.937 2.72726 2.72705 14.9373 2.72705 30C2.72705 45.0627 14.937 57.2727 29.9998 57.2727C45.0625 57.2727 57.2725 45.0627 57.2725 30C57.2725 14.9373 45.0625 2.72726 29.9998 2.72726Z",
    id: "Shape",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.cb94113abf5cf22fa0bdd356f499de4b.svg";
export { ForwardRef as ReactComponent };